import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { TextBox, Button as TextBoxButton } from 'devextreme-react/text-box';
import ValidationGroup from 'devextreme-react/validation-group';
import Validator, { RequiredRule, EmailRule, AsyncRule, StringLengthRule, PatternRule, CompareRule } from 'devextreme-react/validator';
import { CheckBox, SelectBox, TextArea, NumberBox, DateBox } from 'devextreme-react';
import { LoadPanel } from 'devextreme-react/load-panel';
import { LoadIndicator } from 'devextreme-react/load-indicator';
import Button from 'devextreme-react/button';
// import CheckBox from 'devextreme-react/check-box';
import './index.scss';
import { Link } from 'react-router-dom';
import cs from '../../utils/const.js';
import AntString from '../../utils/AntString.js';
import AntLocalization from '../../utils/AntLocalization.js';
import AntBusiness from '../../utils/AntBusiness';
import AntAuth from '../../utils/AntAuth';
import AntLocalStorage from '../../utils/AntLocalStorage';
import AntErrorPanel from '../AntErrorPanel';
import AntTitlePanel from '../AntTitlePanel';
import AntDescPanel from '../AntDescPanel';
import AntCardLayout from '../AntCardLayout';
import md5 from 'md5';

import { AntGlobal, AntSessionContext } from '../../utils/AntContext';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import currencies from '../../data/currencies.json';

export default function (props) {
    const appGlobal = AntGlobal();
    const hasBusShortCode = Boolean(cs.Business_Short_Code);
    const isWhiteLabel = Boolean(cs.Is_White_Label);
    const [currentStage, setCurrentStage] = useState('Step1');
    const [currentToken, setCurrentToken] = useState('');
    const [busShortCode, setBusShortCode] = useState(cs.Business_Short_Code ? cs.Business_Short_Code : '');

    const [message, setMessage] = useState('');
    const [usePhoneNumber, setUsePhoneNumber] = useState(false);
    // country mã ISO-2 (VN, US, JP...) — quyết định:
    //   1. Có hiển thị input số điện thoại không (chỉ VN)
    //   2. Mask số điện thoại nào áp dụng
    //   3. Hint country cho parsePhoneNumberFromString
    const [country, setCountry] = useState('');

    const [ownerPhone, setOwnerPhone] = useState('');
    const [ownerEmail, setOwnerEmail] = useState('');
    const [ownerOTP, setOwnerOTP] = useState('');

    const [adminPassword, setAdminPassword] = useState('');
    const [adminPassword2, setAdminPassword2] = useState('');
    const [errorText, setErrorText] = useState('');
    const [logging, setLogging] = useState(false);

    const blockValidation = useRef(false);

    const vGroup1 = useRef();
    const vGroup3 = useRef();
    const txtBusShortCode = useRef();
    const txtOwnerPhone = useRef();
    const txtOwnerEmail = useRef();
    const txtOwnerOTP = useRef();
    const txtAdminPassword = useRef();
    const txtAdminPassword2 = useRef();

    const busZoneCode = useRef();

    useEffect(() => {
        if (currentStage === 'Step1') if (txtBusShortCode.current && txtBusShortCode.current.instance) txtBusShortCode.current.instance.focus();
        if (currentStage === 'Step2') if (txtOwnerOTP.current && txtOwnerOTP.current.instance) txtOwnerOTP.current.instance.focus();
        if (currentStage === 'Step3') if (txtAdminPassword.current && txtAdminPassword.current.instance) txtAdminPassword.current.instance.focus();
    }, [currentStage]);

    useEffect(() => {
        // Detect country để gate luồng phone OTP. Recovery chạy TRƯỚC login nên không thể
        // tin Sys_BaseCurrency một mình. Thu thập nhiều signal, OR-logic ưu tiên VN: nếu
        // bất kỳ signal nào trỏ về VN thì coi là VN (timezone là tín hiệu vật lý đáng tin
        // nhất, ngay cả khi browser dùng tiếng Anh).
        var signals = [];
        try {
            var baseCurrency = AntLocalStorage.getSetting('Sys_BaseCurrency');
            if (baseCurrency && Array.isArray(currencies)) {
                var curr = currencies.find(function (c) { return c.code === baseCurrency; });
                if (curr && curr.locale && curr.locale.length >= 5) signals.push(curr.locale.slice(-2).toUpperCase());
            }
        } catch (e) { /* ignore */ }
        try {
            var tz = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
            if (tz === 'Asia/Ho_Chi_Minh' || tz === 'Asia/Saigon') signals.push('VN');
        } catch (e) { /* ignore */ }
        try {
            var nav = (navigator && (navigator.language || (navigator.languages && navigator.languages[0]))) || '';
            if (nav && nav.length >= 5 && nav.indexOf('-') > 0) signals.push(nav.slice(-2).toUpperCase());
        } catch (e) { /* ignore */ }
        var detected = signals.indexOf('VN') >= 0 ? 'VN' : (signals[0] || '');
        setCountry(detected);

        // Phone OTP CHỈ bật cho VN. Country khác → email-only, bất kể setting localStorage.
        if (detected === 'VN') {
            var value = localStorage.getItem(cs.System_Code + '-Sys_RegisterWithPhoneNumber');
            value = !value || value === 'null' || value === 'undefined' || value === 'true';
            setUsePhoneNumber(value);
        } else {
            setUsePhoneNumber(false);
        }
    }, []);

    const { appInfo, appAssets } = appGlobal;
    var title = appInfo && appInfo.title ? appInfo.title : '';
    var logoOnly = appAssets && appAssets.images.logoOnly ? appAssets.images.logoOnly : undefined;
    var logoWithBrand = appAssets && appAssets.images.logoWithBrandSlogun ? appAssets.images.logoWithBrandSlogun : undefined;

    const step1_request = useCallback(() => {
        if (!vGroup1.current || !vGroup1.current.instance || !vGroup1.current.instance.validate().isValid) return;

        setErrorText(null);

        const { appInfo } = appGlobal;

        // Country đã detect ở mount (state). Dùng làm hint cho parsePhoneNumberFromString.
        var hintCountry = country || undefined;

        // Normalize phone to E.164 when possible; fallback to legacy VN-ish digits for backwards compat
        var rawPhone = String(ownerPhone || '').replace(/\s/g, '');
        var phone = undefined;
        var phoneCountry = hintCountry;
        if (rawPhone) {
            try {
                var parsed = parsePhoneNumberFromString(rawPhone, hintCountry);
                if (parsed && parsed.isValid()) {
                    phone = parsed.number;
                    phoneCountry = parsed.country || hintCountry;
                }
            } catch (e) { /* ignore */ }
            if (!phone) {
                // Legacy fallback: BE multi-tier match handles VN-local 0xx format
                var p = rawPhone.replace(/[^0-9]/g, '');
                if (p.indexOf('0') != 0) p = '0' + p;
                if (p.indexOf('084') == 0 && p.length == 12) p = '0' + p.substr(3);
                phone = p;
            }
        }

        AntBusiness.recoveryRequest(
            {
                app_id: appInfo.appId,
                // model: busModel,
                short_code: busShortCode,
                owner_phone: phone,
                owner_phone_country: phoneCountry,
                owner_email: ownerEmail
            },
            (res) => {
                if (res && res.error) setErrorText(res.error);
                if (res && res.data && res.data.sent) {
                    busZoneCode.current = res.data.zone_code;
                    setCurrentStage('Step2');
                    setCurrentToken(res.data.token);
                    setOwnerOTP('');

                    if (res && res.data && res.data.message) setMessage(res.data.message);

                    if (txtOwnerOTP.current) txtOwnerOTP.current.instance.focus();
                }
                // this.vGroup1.reset();
            }
        );
    }, [ownerPhone, ownerEmail, busShortCode, appGlobal, country]);

    const step2_verifyOTP = useCallback(
        (otp) => {
            setErrorText(null);

            AntBusiness.recoveryVerifyOTP(
                {
                    token: currentToken,
                    otp: otp,
                    zone_code: busZoneCode.current
                },
                (res) => {
                    if (res && res.error) setErrorText(res.error);
                    if (res && res.data && res.data.valid_otp) {
                        setCurrentStage('Step3');
                        if (txtAdminPassword.current) txtAdminPassword.current.instance.focus();
                    }
                }
            );
        },
        [currentToken]
    );

    const step3_setAdminPassword = useCallback(() => {
        setErrorText(null);
        setCurrentStage('Step4');

        AntBusiness.recoverySetAdminPassword(
            {
                token: currentToken,
                otp: ownerOTP,
                admin_password: md5(AntString.clean(adminPassword)),
                zone_code: busZoneCode.current
            },
            (res) => {
                // Lỗi → quay lại Step3 cho user thấy error + retry (KHÔNG kẹt loading)
                if (res && res.error) {
                    setErrorText(res.error.content || res.error.message || String(res.error));
                    setCurrentStage('Step3');
                    return;
                }

                // Success → save session + bật loading màn hình để Auth reload
                if (res && res.data && res.data.session) {
                    AntAuth.saveSessionData(res.data.session, true);
                    setLogging(true);
                    return;
                }

                // Edge case: response không error nhưng cũng không có session (BE trả {success:false})
                setErrorText(
                    AntLocalization.translateText({
                        vi: 'Khôi phục thất bại, vui lòng thử lại.',
                        en: 'Recovery failed, please try again.',
                        fr: 'Échec de la récupération, veuillez réessayer.',
                        es: 'Recuperación fallida, intente de nuevo.',
                        id: 'Pemulihan gagal, silakan coba lagi.',
                        ja: '復旧に失敗しました、再試行してください。',
                        zh: '恢复失败，请重试。',
                        ko: '복구에 실패했습니다. 다시 시도하세요.',
                        hi: 'पुनर्प्राप्ति विफल, पुनः प्रयास करें।',
                        ar: 'فشل الاسترداد، يرجى المحاولة مرة أخرى.'
                    })
                );
                setCurrentStage('Step3');
            }
        );
    }, [currentToken, ownerOTP, adminPassword]);

    var isStep1Processable = useMemo(
        () =>
            currentStage === 'Step1' &&
            busShortCode &&
            ((ownerPhone && parseInt(ownerPhone)) || (ownerEmail && ownerEmail.indexOf('@') > 0)) &&
            vGroup1.current &&
            vGroup1.current.instance &&
            vGroup1.current.instance.validate().isValid,
        [currentStage, busShortCode, ownerEmail, ownerPhone]
    );

    var isStep3Processable = useMemo(
        () =>
            currentStage === 'Step3' &&
            adminPassword &&
            adminPassword2 &&
            adminPassword === adminPassword2 &&
            vGroup3.current &&
            vGroup3.current.instance &&
            vGroup3.current.instance.validate().isValid,
        [currentStage, adminPassword, adminPassword2]
    );

    if (!logging)
        return (
            <AntCardLayout width={380} scale={1.0} marginLeft={props.marginLeft} marginRight={props.marginRight}>
                <div className={'recovery-header'}>
                    {!logoWithBrand && <div className={'title'}>{appInfo.title}</div>}
                    {logoWithBrand && <img src={logoWithBrand} style={{ width: '120px' }} />}
                </div>
                {/* <AntTitlePanel text={'Khôi phục mật khẩu'} /> */}

                {hasBusShortCode && !isWhiteLabel && (
                    <div className={'dx-field'}>
                        <AntTitlePanel text={busShortCode} center={true} upper={true} />
                    </div>
                )}

                {currentStage === 'Step1' && (
                    <ValidationGroup ref={vGroup1} className={'recovery-panel'}>
                        <div className={'dx-field'}>
                            <AntTitlePanel
                                text={AntLocalization.translateText({ vi: 'Khôi phục mật khẩu quản trị', en: 'Recover admin password', fr: 'Récupérer le mot de passe admin', es: 'Recuperar contraseña de admin', id: 'Pulihkan kata sandi admin', ja: '管理者パスワードを復旧', zh: '恢复管理员密码', ko: '관리자 비밀번호 복구', hi: 'एडमिन पासवर्ड पुनर्प्राप्त करें', ar: 'استعادة كلمة مرور المسؤول' })}
                                center={true}
                            />
                        </div>
                        {/* <div className={'dx-field'}>
                                <SelectBox
                                    ref={(ref) => {
                                        this.txtBusModel = ref ? ref.instance : undefined;
                                    }}
                                    items={[
                                        { code: 'Individual', name: 'Hộ kinh doanh' },
                                        { code: 'Company', name: 'Doanh nghiệp' }
                                    ]}
                                    placeholder={'Loại hình'}
                                    showClearButton={false}
                                    showDropDownButton={false}
                                    className={'recovery-bus-model'}
                                    value={this.state.busModel}
                                    displayExpr={'name'}
                                    valueExpr={'code'}
                                    itemRender={(e) => {
                                        return <div className="recovery-bus-model-name">{e.name}</div>;
                                    }}
                                    onValueChanged={(e) => {
                                        this.setState({ busModel: e.value });
                                        this.txtBusShortCode.focus();
                                    }}
                                >
                                    <Validator>
                                        <RequiredRule message={'Không được trống !'} />
                                    </Validator>
                                    <TextBoxButton
                                        name="busModel"
                                        location="before"
                                        options={{
                                            icon: 'globe',
                                            stylingMode: 'text',
                                            focusStateEnabled: false,
                                            activeStateEnabled: false,
                                            hoverStateEnabled: false,
                                            type: 'default'
                                        }}
                                    />
                                </SelectBox>
                            </div> */}
                        {!hasBusShortCode && (
                            <div className={'dx-field'}>
                                <TextBox
                                    ref={txtBusShortCode}
                                    value={busShortCode}
                                    placeholder={AntLocalization.translateText({ vi: 'Mã doanh nghiệp', en: 'Business Code', fr: 'Code entreprise', es: 'Código de empresa', id: 'Kode Bisnis', ja: 'ビジネスコード', zh: '企业代码', ko: '사업자 코드', hi: 'व्यवसाय कोड', ar: 'رمز العمل' })}
                                    width={'100%'}
                                    className={'recovery-bus-shortcode'}
                                    maxLength={20}
                                    inputAttr={{
                                        style: 'text-transform: uppercase'
                                    }}
                                    onValueChanged={(e) => {
                                        setBusShortCode(String(e.value).toUpperCase().trim().replace(' ', ''));
                                    }}
                                    onEnterKey={(e) => {
                                        // if (this.state.busModel === 'Company') this.txtOwnerEmail.focus();
                                        // else

                                        if (txtOwnerPhone.current) txtOwnerPhone.current.instance.focus();
                                    }}
                                    onFocusIn={(e) => {
                                        let inputEl = e.element.querySelector('.dx-texteditor-input');
                                        if (inputEl) {
                                            inputEl.selectionStart = 0;
                                            inputEl.selectionEnd = inputEl.value.length;
                                        }
                                    }}
                                >
                                    <Validator>
                                        <RequiredRule
                                            message={AntLocalization.translateText({ vi: 'Không được trống !', en: 'Cannot be empty!', fr: 'Ne peut pas être vide !', es: '¡No puede estar vacío!', id: 'Tidak boleh kosong!', ja: '空にできません！', zh: '不能为空！', ko: '비워둘 수 없습니다!', hi: 'खाली नहीं हो सकता!', ar: 'لا يمكن أن يكون فارغاً!' })}
                                        />
                                        <StringLengthRule
                                            message={AntLocalization.translateText({ vi: 'Tối thiểu 5 ký tự', en: 'Minimum 5 characters', fr: 'Minimum 5 caractères', es: 'Mínimo 5 caracteres', id: 'Minimal 5 karakter', ja: '最低5文字', zh: '至少5个字符', ko: '최소 5자', hi: 'न्यूनतम 5 वर्ण', ar: '5 أحرف على الأقل' })}
                                            min={5}
                                        />
                                        <StringLengthRule
                                            message={AntLocalization.translateText({ vi: 'Tối đa 20 ký tự', en: 'Maximum 20 characters', fr: '20 caractères maximum', es: 'Máximo 20 caracteres', id: 'Maksimal 20 karakter', ja: '最大20文字', zh: '最多20个字符', ko: '최대 20자', hi: 'अधिकतम 20 वर्ण', ar: '20 حرفًا كحد أقصى' })}
                                            max={20}
                                        />
                                        <PatternRule
                                            message={AntLocalization.translateText({ vi: 'Không được chứa ký tự đặc biệt !', en: 'Special characters are not allowed!', fr: 'Les caractères spéciaux ne sont pas autorisés !', es: '¡No se permiten caracteres especiales!', id: 'Karakter khusus tidak diizinkan!', ja: '特殊文字は使用できません！', zh: '不允许使用特殊字符！', ko: '특수 문자는 허용되지 않습니다!', hi: 'विशेष वर्णों की अनुमति नहीं है!', ar: 'الأحرف الخاصة غير مسموح بها!' })}
                                            pattern={'^[^\\`~!#$%^&*()=+\\[\\]{}\\|;\':",<>?/]+$'}
                                        />

                                        <PatternRule
                                            message={AntLocalization.translateText({ vi: 'Không được nhập khoảng trắng !', en: 'No spaces allowed !', fr: 'Espaces non autorisés !', es: '¡No se permiten espacios!', id: 'Spasi tidak diizinkan!', ja: 'スペースは使用できません！', zh: '不允许输入空格！', ko: '공백은 허용되지 않습니다!', hi: 'रिक्त स्थान की अनुमति नहीं है!', ar: 'المسافات غير مسموح بها!' })}
                                            pattern={/^[^\s]+$/}
                                        />
                                        <AsyncRule
                                            message={AntLocalization.translateText({ vi: 'Mã doanh nghiệp không tồn tại !', en: 'Enterprise code does not exist!', fr: "Le code d'entreprise n'existe pas !", es: '¡El código de empresa no existe!', id: 'Kode bisnis tidak ditemukan!', ja: '企業コードが存在しません！', zh: '企业代码不存在！', ko: '사업자 코드가 존재하지 않습니다!', hi: 'व्यवसाय कोड मौजूद नहीं है!', ar: 'رمز العمل غير موجود!' })}
                                            validationCallback={async (e) => {
                                                if (blockValidation.current) return true;
                                                blockValidation.current = true;
                                                var isExisted = await AntBusiness.isShortCodeExisted(String(e.value));
                                                blockValidation.current = false;
                                                return Boolean(isExisted);
                                            }}
                                        />
                                    </Validator>
                                    <TextBoxButton
                                        name="busShortCode"
                                        location="before"
                                        options={{
                                            icon: 'key',
                                            stylingMode: 'text',
                                            focusStateEnabled: false,
                                            activeStateEnabled: false,
                                            hoverStateEnabled: false,
                                            type: 'default'
                                        }}
                                    />
                                </TextBox>
                            </div>
                        )}
                        {/* {this.state.busModel === 'Individual' && ( */}

                        {/* <div className={'dx-field'}>
                                <AntDescPanel text={'Nhập số điện thoại để nhận mã OTP :'} />
                            </div> */}

                        {usePhoneNumber && (
                            <div className={'dx-field'}>
                                <TextBox
                                    ref={txtOwnerPhone}
                                    value={ownerPhone}
                                    placeholder={AntLocalization.translateText({ vi: 'Số điện thoại', en: 'Phone Number', fr: 'Numéro de téléphone', es: 'Número de teléfono', id: 'Nomor telepon', ja: '電話番号', zh: '电话号码', ko: '전화번호', hi: 'फ़ोन नंबर', ar: 'رقم الهاتف' })}
                                    width={'100%'}
                                    className={'recovery-owner-phone'}
                                    mask={country === 'VN' ? 'X000 000 000' : '0000000000000'}
                                    maskRules={country === 'VN' ? { X: /[02-9]/ } : {}}
                                    maskInvalidMessage={AntLocalization.translateText({ vi: 'Số điện thoại không hợp lệ', en: 'Invalid phone number', fr: 'Numéro de téléphone invalide', es: 'Número de teléfono no válido', id: 'Nomor telepon tidak valid', ja: '無効な電話番号', zh: '无效的电话号码', ko: '유효하지 않은 전화번호', hi: 'अमान्य फ़ोन नंबर', ar: 'رقم هاتف غير صالح' })}
                                    showMaskMode={'onFocus'}
                                    onValueChanged={(e) => {
                                        setOwnerPhone(e.value);
                                    }}
                                    onEnterKey={step1_request}
                                    onFocusIn={(e) => {
                                        let inputEl = e.element.querySelector('.dx-texteditor-input');
                                        if (inputEl) {
                                            inputEl.selectionStart = 0;
                                            inputEl.selectionEnd = inputEl.value.length;
                                        }
                                    }}
                                >
                                    <Validator>
                                        {/* <RequiredRule
                                        message={AntLocalization.translateText({ vi: 'Không được trống !', en: 'Cannot be empty!', fr: 'Ne peut pas être vide !', es: '¡No puede estar vacío!', id: 'Tidak boleh kosong!', ja: '空にできません！', zh: '不能为空！', ko: '비워둘 수 없습니다!', hi: 'खाली नहीं हो सकता!', ar: 'لا يمكن أن يكون فارغاً!' })}
                                    /> */}
                                        {/* <StringLengthRule
                                        message={AntLocalization.translateText({ vi: 'Tối thiểu 10 ký tự', en: 'Minimum 10 characters', fr: '10 caractères minimum', es: 'Mínimo 10 caracteres', id: 'Minimal 10 karakter', ja: '最低10文字', zh: '至少10个字符', ko: '최소 10자', hi: 'न्यूनतम 10 वर्ण', ar: '10 أحرف على الأقل' })}
                                        min={10}
                                    /> */}
                                        <StringLengthRule
                                            message={AntLocalization.translateText({ vi: 'Tối đa 12 ký tự', en: 'Maximum 12 characters', fr: '12 caractères maximum', es: 'Máximo 12 caracteres', id: 'Maksimal 12 karakter', ja: '最大12文字', zh: '最多12个字符', ko: '최대 12자', hi: 'अधिकतम 12 वर्ण', ar: '12 حرفًا كحد أقصى' })}
                                            max={12}
                                        />
                                        <PatternRule
                                            message={AntLocalization.translateText({ vi: 'Không được chứa ký tự đặc biệt !', en: 'Special characters are not allowed!', fr: 'Les caractères spéciaux ne sont pas autorisés !', es: '¡No se permiten caracteres especiales!', id: 'Karakter khusus tidak diizinkan!', ja: '特殊文字は使用できません！', zh: '不允许使用特殊字符！', ko: '특수 문자는 허용되지 않습니다!', hi: 'विशेष वर्णों की अनुमति नहीं है!', ar: 'الأحرف الخاصة غير مسموح بها!' })}
                                            pattern={'^[^\\`~!#$%^&*()=+\\[\\]{}\\|;\':",<>?/]+$'}
                                        />
                                    </Validator>
                                    <TextBoxButton
                                        name="ownerPhone"
                                        location="before"
                                        options={{
                                            icon: 'tel',
                                            stylingMode: 'text',
                                            focusStateEnabled: false,
                                            activeStateEnabled: false,
                                            hoverStateEnabled: false,
                                            type: 'default'
                                        }}
                                    />
                                </TextBox>
                            </div>
                        )}

                        <div className={'dx-field'}>
                            <TextBox
                                ref={txtOwnerEmail}
                                value={ownerEmail}
                                placeholder={'Email'}
                                width={'100%'}
                                mode="email"
                                className={'register-owner-email'}
                                maxLength={64}
                                onValueChanged={(e) => {
                                    setOwnerEmail(String(e.value).toLowerCase().trim().replace(' ', ''));
                                }}
                                // onEnterKey={step1_request}
                                onEnterKey={() => setTimeout(step1_request, 1000)}
                            >
                                <Validator>
                                    <EmailRule message={'Không đúng định dạng !'} />
                                    <StringLengthRule message="Tối đa 64 ký tự" max={64} />
                                    <PatternRule message="Không được chứa ký tự đặc biệt !" pattern={'^[^\\`~!#$%^&*()=+\\[\\]{}\\|;\':",<>?/]+$'} />
                                </Validator>
                                <TextBoxButton
                                    name="ownerEmail"
                                    location="before"
                                    options={{
                                        icon: 'email',
                                        stylingMode: 'text',
                                        focusStateEnabled: false,
                                        activeStateEnabled: false,
                                        hoverStateEnabled: false,
                                        type: 'default'
                                    }}
                                />
                            </TextBox>
                        </div>
                        {/* )} */}
                        {/* {this.state.busModel === 'Company' && (
                                <div className={'dx-field'}>
                                    <TextBox
                                        ref={(ref) => {
                                            this.txtOwnerEmail = ref ? ref.instance : undefined;
                                        }}
                                        value={this.state.ownerEmail}
                                        placeholder={'Email'}
                                        width={'100%'}
                                        mode="email"
                                        className={'recovery-owner-email'}
                                        maxLength={64}
                                        onValueChanged={(e) => {
                                            this.setState({ ownerEmail: String(e.value).toLowerCase().trim().replace(' ', '') });
                                        }}
                                        onEnterKey={this.step1_request}
                                    >
                                        <Validator>
                                            <EmailRule message={'Không đúng định dạng !'} />
                                            <RequiredRule message={'Không được trống !'} />
                                            <StringLengthRule message="Tối thiểu 10 ký tự" min={10} />
                                            <StringLengthRule message="Tối đa 64 ký tự" max={64} />
                                            <PatternRule
                                                message="Không được chứa ký tự đặc biệt !"
                                                pattern={'^[^\\`~!@#$%^&*()=+\\[\\]{}\\|;\':",.<>?/]+$'}
                                            />
                                        </Validator>
                                        <TextBoxButton
                                            name="ownerEmail"
                                            location="before"
                                            options={{
                                                icon: 'email',
                                                stylingMode: 'text',
                                                focusStateEnabled: false,
                                                activeStateEnabled: false,
                                                hoverStateEnabled: false,
                                                type: 'default'
                                            }}
                                        />
                                    </TextBox>
                                </div>
                            )} */}
                        <div className={'dx-field'}>
                            <Button
                                type={'default'}
                                text={AntLocalization.translateText({ vi: 'LẤY MÃ OTP', en: 'GET OTP', fr: 'OBTENIR LE CODE', es: 'OBTENER CÓDIGO', id: 'DAPATKAN KODE', ja: 'コードを取得', zh: '获取验证码', ko: '인증코드 받기', hi: 'कोड प्राप्त करें', ar: 'احصل على الرمز' })}
                                disabled={!isStep1Processable}
                                onClick={step1_request}
                                width={'100%'}
                                style={{ fontWeight: 500 }}
                            />
                        </div>
                    </ValidationGroup>
                )}

                {currentStage === 'Step2' && (
                    <div>
                        {!message && (
                            <div className={'dx-field'}>
                                <AntDescPanel
                                    text={AntLocalization.translateText({ vi: 'Mã xác nhận đã được gửi đến số điện thoại của bạn', en: 'A confirmation code has been sent to your phone number', fr: 'Un code de confirmation a été envoyé à votre numéro', es: 'Se ha enviado un código de confirmación a su teléfono', id: 'Kode konfirmasi telah dikirim ke nomor telepon Anda', ja: '確認コードが電話番号に送信されました', zh: '验证码已发送至您的手机号码', ko: '인증코드가 전화번호로 전송되었습니다', hi: 'आपके फ़ोन नंबर पर पुष्टि कोड भेजा गया है', ar: 'تم إرسال رمز التأكيد إلى رقم هاتفك' })}
                                />
                                <AntDescPanel
                                    text={AntLocalization.translateText({ vi: 'Vui lòng kiểm tra tin nhắn và nhập lại :', en: 'Please check your message and re-enter:', fr: 'Veuillez vérifier votre message et saisir le code :', es: 'Por favor revise su mensaje e ingrese el código:', id: 'Silakan periksa pesan Anda dan masukkan kembali:', ja: 'メッセージを確認してコードを入力してください：', zh: '请查看短信并输入验证码：', ko: '메시지를 확인하고 코드를 입력하세요:', hi: 'कृपया अपना संदेश जाँचें और कोड दर्ज करें:', ar: 'يرجى التحقق من رسالتك وإعادة الإدخال:' })}
                                />
                            </div>
                        )}
                        {message && (
                            <div className={'dx-field'}>
                                <AntDescPanel text={message} />
                            </div>
                        )}

                        {/* {this.state.busModel === 'Individual' && (
                                <div className={'dx-field'}>
                                    <AntDescPanel text={'Mã xác nhận đã được gửi đến số ' + ownerPhone} />
                                    <AntDescPanel text={'Vui lòng kiểm tra tin nhắn và nhập lại :'} />
                                </div>
                            )}

                            {this.state.busModel === 'Company' && (
                                <div className={'dx-field'}>
                                    <AntDescPanel text={'Mã xác nhận đã được gửi đến hộp thư ' + this.state.ownerEmail} />
                                    <AntDescPanel text={'Vui lòng kiểm tra và nhập lại :'} />
                                </div>
                            )} */}

                        <div className={'dx-field'}>
                            <TextBox
                                ref={txtOwnerOTP}
                                value={ownerOTP}
                                placeholder={'OTP'}
                                width={'100%'}
                                className={'recovery-owner-phone-otp'}
                                mask="0 0 0 0 0 0"
                                maskRules={{ X: /[02-9]/ }}
                                maskInvalidMessage={null}
                                // validationStatus="valid"
                                valueChangeEvent="keyup"
                                onValueChanged={(e) => {
                                    setOwnerOTP(e.value);
                                    setErrorText(null);
                                    if (String(e.value).trim().length === 6) step2_verifyOTP(String(e.value).trim());
                                }}
                                onFocusIn={(e) => {
                                    let inputEl = e.element.querySelector('.dx-texteditor-input');
                                    if (inputEl) {
                                        inputEl.selectionStart = 0;
                                        inputEl.selectionEnd = inputEl.value.length;
                                    }
                                }}
                            />
                        </div>
                    </div>
                )}

                {currentStage === 'Step3' && (
                    <ValidationGroup ref={vGroup3} className={'recovery-panel'}>
                        <div className={'dx-field'}>
                            <AntDescPanel
                                text={
                                    AntLocalization.translateText({
                                        vi: "Cập nhật mật khẩu cho tài khoản '",
                                        en: "Update password for account '",
                                        fr: "Mettre à jour le mot de passe du compte '",
                                        es: "Actualizar contraseña de la cuenta '",
                                        id: "Perbarui kata sandi untuk akun '",
                                        ja: "アカウントのパスワードを更新 '",
                                        zh: "更新账户密码 '",
                                        ko: "계정 비밀번호 업데이트 '",
                                        hi: "खाते का पासवर्ड अपडेट करें '",
                                        ar: "تحديث كلمة المرور للحساب '"
                                    }) +
                                    busShortCode +
                                    "' :"
                                }
                            />
                        </div>

                        <div className={'dx-field'}>
                            <TextBox
                                ref={txtAdminPassword}
                                value={adminPassword}
                                mode={'password'}
                                placeholder={AntLocalization.translateText({ vi: 'Mật khẩu', en: 'Password', fr: 'Mot de passe', es: 'Contraseña', id: 'Kata sandi', ja: 'パスワード', zh: '密码', ko: '비밀번호', hi: 'पासवर्ड', ar: 'كلمة المرور' })}
                                width={'100%'}
                                className={'recovery-admin-password'}
                                onValueChanged={(e) => {
                                    setAdminPassword(e.value);
                                    setErrorText(null);
                                }}
                                onEnterKey={(e) => {
                                    if (txtAdminPassword2.current) txtAdminPassword2.current.instance.focus();
                                }}
                                onFocusIn={(e) => {
                                    let inputEl = e.element.querySelector('.dx-texteditor-input');
                                    if (inputEl) {
                                        inputEl.selectionStart = 0;
                                        inputEl.selectionEnd = inputEl.value.length;
                                    }
                                }}
                            >
                                <Validator>
                                    <RequiredRule
                                        message={AntLocalization.translateText({ vi: 'Không được trống !', en: 'Cannot be empty!', fr: 'Ne peut pas être vide !', es: '¡No puede estar vacío!', id: 'Tidak boleh kosong!', ja: '空にできません！', zh: '不能为空！', ko: '비워둘 수 없습니다!', hi: 'खाली नहीं हो सकता!', ar: 'لا يمكن أن يكون فارغاً!' })}
                                    />
                                    <StringLengthRule
                                        message={AntLocalization.translateText({ vi: 'Tối thiểu 6 ký tự', en: 'Minimum 6 characters', fr: '6 caractères minimum', es: 'Mínimo 6 caracteres', id: 'Minimal 6 karakter', ja: '最低6文字', zh: '至少6个字符', ko: '최소 6자', hi: 'न्यूनतम 6 वर्ण', ar: '6 أحرف على الأقل' })}
                                        min={6}
                                    />
                                    <StringLengthRule
                                        message={AntLocalization.translateText({ vi: 'Tối đa 64 ký tự', en: 'Maximum 64 characters', fr: '64 caractères maximum', es: 'Máximo 64 caracteres', id: 'Maksimal 64 karakter', ja: '最大64文字', zh: '最多64个字符', ko: '최대 64자', hi: 'अधिकतम 64 वर्ण', ar: '64 حرفًا كحد أقصى' })}
                                        max={64}
                                    />
                                </Validator>
                                <TextBoxButton
                                    name="adminPassword"
                                    location="before"
                                    options={{
                                        icon: 'key',
                                        stylingMode: 'text',
                                        focusStateEnabled: false,
                                        activeStateEnabled: false,
                                        hoverStateEnabled: false,
                                        type: 'default'
                                    }}
                                />
                            </TextBox>
                        </div>

                        <div className={'dx-field'}>
                            <TextBox
                                ref={txtAdminPassword2}
                                value={adminPassword2}
                                mode={'password'}
                                placeholder={AntLocalization.translateText({ vi: 'Nhập lại', en: 'Re-enter', fr: 'Confirmer', es: 'Confirmar', id: 'Masukkan ulang', ja: '再入力', zh: '确认密码', ko: '재입력', hi: 'पुनः दर्ज करें', ar: 'أعد الإدخال' })}
                                width={'100%'}
                                className={'recovery-admin-password'}
                                onValueChanged={(e) => {
                                    setAdminPassword2(e.value);
                                    setErrorText(null);
                                }}
                                onFocusIn={(e) => {
                                    let inputEl = e.element.querySelector('.dx-texteditor-input');
                                    if (inputEl) {
                                        inputEl.selectionStart = 0;
                                        inputEl.selectionEnd = inputEl.value.length;
                                    }
                                }}
                                onEnterKey={step3_setAdminPassword}
                            >
                                <Validator>
                                    <RequiredRule
                                        message={AntLocalization.translateText({ vi: 'Không được trống !', en: 'Cannot be empty!', fr: 'Ne peut pas être vide !', es: '¡No puede estar vacío!', id: 'Tidak boleh kosong!', ja: '空にできません！', zh: '不能为空！', ko: '비워둘 수 없습니다!', hi: 'खाली नहीं हो सकता!', ar: 'لا يمكن أن يكون فارغاً!' })}
                                    />
                                    <CompareRule
                                        message={AntLocalization.translateText({ vi: 'Mật khẩu không khớp !', en: 'Passwords do not match !', fr: 'Mots de passe différents !', es: '¡Las contraseñas no coinciden!', id: 'Kata sandi tidak cocok!', ja: 'パスワードが一致しません！', zh: '密码不匹配！', ko: '비밀번호가 일치하지 않습니다!', hi: 'पासवर्ड मेल नहीं खाते!', ar: 'كلمات المرور غير متطابقة!' })}
                                        comparisonTarget={() => {
                                            return adminPassword;
                                        }}
                                    />
                                </Validator>
                                <TextBoxButton
                                    name="adminPassword2"
                                    location="before"
                                    options={{
                                        icon: 'key',
                                        stylingMode: 'text',
                                        focusStateEnabled: false,
                                        activeStateEnabled: false,
                                        hoverStateEnabled: false,
                                        type: 'default'
                                    }}
                                />
                            </TextBox>
                        </div>

                        <div className={'dx-field'}>
                            <Button
                                type={'default'}
                                text={AntLocalization.translateText({ vi: 'TIẾP TỤC', en: 'NEXT', fr: 'SUIVANT', es: 'SIGUIENTE', id: 'LANJUT', ja: '次へ', zh: '下一步', ko: '다음', hi: 'अगला', ar: 'التالي' })}
                                disabled={!isStep3Processable}
                                onClick={step3_setAdminPassword}
                                width={'100%'}
                                style={{ fontWeight: 500 }}
                            />
                        </div>
                    </ValidationGroup>
                )}

                {currentStage === 'Step4' && (
                    <div className={'dx-field'} style={{ textAlign: 'center' }}>
                        <LoadIndicator className={'recovery-loading'} />
                    </div>
                )}

                <div className={'dx-field'} style={{ marginLeft: '-18px' }}>
                    {errorText && <AntErrorPanel text={errorText} transparent={true} />}
                </div>
                <div className={'dx-field'}>
                    <Link to={'/login'}>
                        {AntLocalization.translateText({ vi: 'Đăng nhập tại đây.', en: 'Log in here.', fr: 'Connectez-vous ici.', es: 'Inicie sesión aquí.', id: 'Masuk di sini.', ja: 'こちらからログイン', zh: '在此登录', ko: '여기서 로그인', hi: 'यहाँ लॉगिन करें', ar: 'سجّل الدخول هنا.' })}
                    </Link>
                </div>
                {!hasBusShortCode && (
                    <div className={'dx-field'}>
                        <Link to={'/register'}>
                            {AntLocalization.translateText({ vi: 'Đăng ký để bắt đầu kinh doanh', en: 'Sign up to start your business', fr: "S'inscrire pour démarrer votre entreprise", es: 'Regístrese para iniciar su negocio', id: 'Daftar untuk memulai bisnis Anda', ja: 'ビジネスを始めるために登録', zh: '注册开始您的业务', ko: '비즈니스를 시작하려면 가입하세요', hi: 'अपना व्यवसाय शुरू करने के लिए साइन अप करें', ar: 'سجّل لبدء عملك' })}
                        </Link>
                    </div>
                )}
            </AntCardLayout>
        );

    return (
        <div>
            <LoadPanel
                visible={true}
                showPane={false}
                shading={false}
                // shadingColor={'rgba(255, 255, 255, 1)'}
                // indicatorSrc={'https://image.flaticon.com/icons/svg/3305/3305803.svg'}

                wrapperAttr={{
                    class: 'ant-loading'
                }}
            />
        </div>
    );
}
